{
  "blocks": [
    {
      "id": "med-dexamethasone",
      "kind": "medication",
      "tags": [
        "medications",
        "her",
        "during-cycle",
        "ivf",
        "fet",
        "evidence-based"
      ],
      "title": "Dexamethasone",
      "subtitle": "Corticosteroid used for immune modulation and androgen reduction",
      "body": {
        "genericName": "Dexamethasone",
        "drugClass": "Corticosteroid (glucocorticoid)",
        "purpose": "Some clinics use dexamethasone for selected endocrine or immune indications. Whether it belongs in an FET plan, and what it is intended to treat, depends on your clinician's review and individual history. Evidence and use vary, so this article cannot determine whether it is appropriate for you.",
        "commonRoutes": ["oral"],
        "commonForms": ["pill"],
        "dosageRanges": "There is no universal FET dose or schedule. Your clinic or prescribing clinician must confirm the product, dose, route, start and stop dates, and whether any taper is needed.",
        "howToTake": "Use dexamethasone only as prescribed and follow the directions on your clinic's order or pharmacy label. Do not start, stop, change the dose, or change the timing from this article. Ask your clinic or pharmacist what to do if a dose is late or missed, and whether you need a taper before stopping. Contact your care team about symptoms that concern you, including marked mood changes, swelling, symptoms of high blood sugar, or difficulty following the prescribed plan.",
        "sideEffects": [
          "Increased appetite and mild weight gain",
          "Insomnia (take at bedtime to minimize)",
          "Mood changes or irritability",
          "Elevated blood sugar (especially in PMOS (ex PCOS) patients)",
          "Mild stomach upset",
          "Immune suppression with prolonged use",
          "Easy bruising (with longer courses)"
        ],
        "storage": "Store at room temperature (15-30°C / 59-86°F). Protect from moisture and light.",
        "brandsByCountry": [
          {
            "country": "US",
            "brands": ["Decadron", "generic dexamethasone"]
          },
          {
            "country": "UK",
            "brands": ["Dexamethasone", "Neofordex"]
          },
          {
            "country": "EU",
            "brands": ["Dexamethasone", "Fortecortin"]
          },
          {
            "country": "AU",
            "brands": ["Dexamethasone"]
          },
          {
            "country": "FR",
            "brands": ["Dectancyl", "Dexaméthasone Mylan"],
            "cisByBrand": {
              "Dectancyl": "62817482"
            }
          }
        ],
        "aliases": ["Dexaméthasone", "Dectancyl", "Soludécadron"],
        "forWhom": "her",
        "frBody": {
          "genericName": "Dexaméthasone",
          "drugClass": "Corticoïde (glucocorticoïde)",
          "purpose": "Certains centres utilisent la dexaméthasone dans des indications endocriniennes ou immunitaires sélectionnées. Sa place dans un plan de TEC et son objectif dépendent de l'évaluation de votre clinicien et de vos antécédents. Les usages et les données varient ; cet article ne permet pas de déterminer si elle vous convient.",
          "dosageRanges": "Il n'existe pas de dose ni de calendrier universels pour un TEC. Votre centre ou le prescripteur doit confirmer le produit, la dose, la voie, les dates de début et d'arrêt, ainsi que la nécessité éventuelle d'une diminution progressive.",
          "howToTake": "Utilisez la dexaméthasone uniquement sur prescription et suivez l'ordonnance de votre centre ou l'étiquette de la pharmacie. Ne commencez pas, n'arrêtez pas, ne modifiez pas la dose et ne changez pas le calendrier à partir de cet article. Demandez à votre centre ou à votre pharmacien quoi faire en cas de dose retardée ou oubliée, et si une diminution progressive est nécessaire avant l'arrêt. Contactez votre équipe en cas de symptôme préoccupant, notamment changement d'humeur marqué, œdèmes, signes d'hyperglycémie ou difficulté à suivre le plan prescrit.",
          "sideEffects": [
            "Augmentation de l'appétit et légère prise de poids",
            "Insomnie (prise au coucher pour limiter cet effet)",
            "Changements d'humeur ou irritabilité",
            "Élévation de la glycémie (surtout chez les patientes PMOS (ex SOPK))",
            "Inconfort gastrique léger",
            "Immunosuppression en cas d'utilisation prolongée",
            "Ecchymoses faciles (en cure prolongée)"
          ],
          "storage": "Conservez à température ambiante (15-30 °C). À protéger de l'humidité et de la lumière."
        }
      }
    }
  ],
  "relationships": [],
  "localeVariants": []
}
